import { Fragment } from 'react'

import { Table, Tr, Th } from 'app/common/ui-components/table'
import { Org, TotalItem } from 'app/dataTypes/reports/data/common/ordersByClasses'

import QuadLineCell from './quad-line-cell'
import styles from './left-table.scss'


type Props = {
  className?: string
  sameRowClassBase?: string
  data?: Array<Org>
  total?: Array<TotalItem>
  onMouseEnter?: (e: React.MouseEvent) => void
  onMouseLeave?: (e: React.MouseEvent) => void
}

const LeftTable = ({
  className,
  sameRowClassBase = 'row_',
  data,
  total,
  onMouseEnter,
  onMouseLeave,
}: Props) => {
  const middlePosition = !!data
  const bottomPosition = !!total

  return (
    <Table className={className}>
      <thead>
        <Tr header hidden={middlePosition || bottomPosition}>
          <Th
            scope="col"
            alignLeft
            bgFilled
          >
            {'Заведение'}
          </Th>
          <Th
            scope="col"
            alignLeft
            bgFilled
          >
            {'Категория обучающихся'}
          </Th>
        </Tr>
      </thead>

      {data
        && <tbody>
          {data.map(({
            id,
            title,
          }, rowIndex) => (
            <Fragment key={id}>
              <Tr
                className={`${sameRowClassBase}${rowIndex}`}
                onMouseEnter={onMouseEnter}
                onMouseLeave={onMouseLeave}
                interlineBorder
              >
                <Th
                  alignLeft
                  className={styles.org}
                >
                  <div className={styles.limitedCell}>
                    {title}
                  </div>
                </Th>
                <Th
                  alignLeft
                  borderBottom={false}
                >
                  <QuadLineCell
                    line1="1–4 классы"
                    line2="5–9 классы"
                    line3="10–11 классы"
                    line4="ИТОГО"
                  />
                </Th>
              </Tr>
            </Fragment>
          ))}
        </tbody>}

      {total
        && <tfoot>
          <Tr
            hidden={!bottomPosition}
            headerHasBorderBottom={false}
            header
          >
            <Th
              className={styles.org}
              alignLeft
              bgFilled
            >
              &nbsp;
            </Th>
            <Th
              className={styles.summary}
              alignLeft
              bgFilled
            >
              {'ИТОГО'}
            </Th>
          </Tr>
        </tfoot>}
    </Table>
  )
}

export default LeftTable
